import { BaseDto } from '../base.dto';

export class InvoiceBillingItemDto extends BaseDto {
  billingInvoiceId?: number;
  itemName: string;
  itemDescription?: string;
  itemPrice: number;
  itemQuantity: number;
  itemAmount: number;
  itemVatClass: string;
  itemVatValue: number;
  itemVatAmount: number;
}
